var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21653 19.7521C9.31976 19.907 9.49358 20 9.67969 20C9.86579 20 10.0396 19.907 10.1428 19.7521C11.4602 17.7761 13.4005 15.3358 14.7527 12.8539C15.8338 10.8694 16.3594 9.1769 16.3594 7.67969C16.3594 3.99651 13.3629 1 9.67969 1C5.99651 1 3 3.99651 3 7.67969C3 9.1769 3.52558 10.8694 4.60672 12.8539C5.95784 15.3339 7.90189 17.7802 9.21653 19.7521ZM9.67969 2.11328C12.749 2.11328 15.2461 4.61037 15.2461 7.67969C15.2461 8.98609 14.7649 10.5044 13.775 12.3213C12.6095 14.4606 10.9464 16.6307 9.67969 18.4551C8.41318 16.631 6.7499 14.4607 5.58433 12.3213C4.59448 10.5044 4.11328 8.98609 4.11328 7.67969C4.11328 4.61037 6.61037 2.11328 9.67969 2.11328Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M9.67969 11.0195C11.5213 11.0195 13.0195 9.52128 13.0195 7.67969C13.0195 5.8381 11.5213 4.33984 9.67969 4.33984C7.8381 4.33984 6.33984 5.8381 6.33984 7.67969C6.33984 9.52128 7.8381 11.0195 9.67969 11.0195ZM9.67969 5.45312C10.9074 5.45312 11.9062 6.45196 11.9062 7.67969C11.9062 8.90741 10.9074 9.90625 9.67969 9.90625C8.45196 9.90625 7.45312 8.90741 7.45312 7.67969C7.45312 6.45196 8.45196 5.45312 9.67969 5.45312Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fd2f0b60297b3e99a0a74d4bcf9e4f0f.svg";
export { ForwardRef as ReactComponent };